// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2WBEc","inner":"Form_inner__32Xag","range":"Form_range__JcN1V","name":"Form_name__3IJsI","actions":"Form_actions__1MYQ9"};